import { createSelector } from 'reselect';
import sysUtils from 'utils/ShopYourStore';

// Dummy selector, is going to be changed later.
const inventoryAwareStorePickerAbTestSelector = createSelector(() => true);

const isInventoryAwareStorePickerEnabledSelector = createSelector(inventoryAwareStorePickerAbTestSelector, inventoryAwareStorePickerAbTest => {
    const globalKillswitch = sysUtils.inventoryAwareStorePickerEnabled();
    const isInventoryAwareStorePickerEnabled = globalKillswitch && inventoryAwareStorePickerAbTest;

    return isInventoryAwareStorePickerEnabled;
});

export { isInventoryAwareStorePickerEnabledSelector };
